import { useEffect, useState } from 'react';
import type { ScanProgress, ScanService } from './types.ts';

/** The queue's progress, kept current. */
export function useScanProgress(service: ScanService | undefined): ScanProgress | undefined {
  const [progress, setProgress] = useState(service?.progress());
  useEffect(() => {
    if (!service) return;
    setProgress(service.progress());
    return service.subscribe(() => setProgress(service.progress()));
  }, [service]);
  return progress;
}
